import React, { createContext, useContext, useState } from 'react';

const PopoverContext = createContext();

export const ArrivedPopupProvider = ({ children }) => {
    const [isOpenPopovers, setIsOpenPopovers] = useState({}); 
    const [popoversAnchors, setPopoversAnchors] = useState({});
	
    // initialize the popover and set its anchor element
    const addAnchor = (prefix, anchorEl) => {
        setPopoversAnchors((prev) => ({
            ...prev,
            [prefix]: anchorEl,
        }));
    };

    const open = (prefix) => {
        setIsOpenPopovers((prev) => ({
            ...prev,
            [prefix]: popoversAnchors[prefix] ? true : prev[prefix],
        }));
    };

    const close = (prefix) => {
        setIsOpenPopovers((prev) => ({
            ...prev,
            [prefix]: false, 
        }));
    };

    return (
        <PopoverContext.Provider value={{ isOpenPopovers, popoversAnchors, addAnchor, open, close }}>
            {children}
        </PopoverContext.Provider>
    );
};


export const useArrivedPopupContext = () => {
    return useContext(PopoverContext);
};
